module.exports = __webpack_public_path__ + "static/biancaWallpaper3-06d7e85f90fce592f77d4e0cd6816f51.jpg";